import {LOCALE_ID, NgModule} from '@angular/core';
import {CommonModule, registerLocaleData} from '@angular/common';
import {AppExamComponent} from './exam.component';
import {RouterModule, Routes} from '@angular/router';
import {CoreModule} from '@core/core.module';
import {ExtendedModule, FlexModule} from '@angular/flex-layout';
import {HelpersModule} from '@shared/helpers/helpers.module';
import {SharedModule} from '@shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import {AppExamAssignDialogComponent} from '@component/exam/assign-dialog/assign-dialog.component';
import {MatRadioModule} from '@angular/material/radio';
import {ContainerHeaderModule} from '@component/container-header/container-header.module';
import {AppSelectModule} from '@component/form/input/select/select.module';
import {UserNameOrMailModule} from '@component/user-name-or-mail/user-name-or-mail.module';
import {CardExamModule} from '@component/exam/card-exam/card-exam.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import localeNl from '@angular/common/locales/nl';
import {ExamDeleteDialogComponent} from '@component/exam/exam-delete-dialog/exam-delete-dialog.component';
import {ExamQuestionListComponent} from '@component/exam/exam-question-list/exam-question-list.component';
import {FormsModule} from '@angular/forms';
import {FilterUnansweredPipe} from '@component/exam/exam-question-list/pipe/filter-un-answered.pipe';
import {UnansweredCountPipe} from '@component/exam/exam-question-list/pipe/count-un-answered.pipe';

registerLocaleData(localeNl, 'nl');

const routes: Routes = [
    {
        path: '',
        component: AppExamComponent,
    },
];

@NgModule({
    declarations: [
        AppExamComponent,
        AppExamAssignDialogComponent,
        ExamDeleteDialogComponent,
        ExamQuestionListComponent,
        FilterUnansweredPipe,
        UnansweredCountPipe,
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        ContainerHeaderModule,
        CoreModule,
        ExtendedModule,
        FlexModule,
        HelpersModule,
        SharedModule,
        TranslateModule,
        MatRadioModule,
        AppSelectModule,
        UserNameOrMailModule,
        CardExamModule,
        MatExpansionModule,
        MatProgressBarModule,
        FormsModule,
    ],
    exports: [
        AppExamComponent,
        AppExamAssignDialogComponent,
        ExamDeleteDialogComponent,
        ExamQuestionListComponent,
        FilterUnansweredPipe,
        UnansweredCountPipe,
    ],
    providers: [
        {provide: LOCALE_ID, useValue: 'nl'},
    ],
})
export class AppExamModule {
}
